module.exports = __webpack_public_path__ + "img/finish_flag.b13b1320.png";